export var ValidateParamsExchange;
(function (ValidateParamsExchange) {
    ValidateParamsExchange["Email"] = "Email";
    ValidateParamsExchange["Mobile"] = "Mobile";
    ValidateParamsExchange["Address"] = "Address";
    ValidateParamsExchange["IncomeRange"] = "IncomeRange";
    ValidateParamsExchange["PANNO"] = "PANNO";
    ValidateParamsExchange["Name"] = "Name";
    ValidateParamsExchange["IsPassFail"] = "IsPassFail";
    ValidateParamsExchange["IsValidDays"] = "IsValidDays";
})(ValidateParamsExchange || (ValidateParamsExchange = {}));
